import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ALL_EVENT_TYPES, EVENT_TYPE_URL } from '@/constants';
import { apiUrl, getQueryParams } from '@/helpers';

const eventTypeEndpoints = {
  getAll: (customAttributeTemplateId?: number, organizationId?: number) =>
    axios.get(
      `${apiUrl()}${EVENT_TYPE_URL}/all${getQueryParams({
        'filter.CustomAttributeTemplates[0].Id': customAttributeTemplateId as number,
        'filter.Organizations[0].Id': organizationId as number
      })}`
    )
};

export const useGetAllEventTypes = (
  filterByCustomAttributeTemplateId?: number,
  filterByOrganizationId?: number,
  enabled?: boolean
) => {
  return useQuery(
    [ALL_EVENT_TYPES, { filterByCustomAttributeTemplateId, filterByOrganizationId }],
    () => eventTypeEndpoints.getAll(filterByCustomAttributeTemplateId, filterByOrganizationId),
    { enabled: enabled ?? true }
  );
};
